import {
    EquipmentSet,
    PostEquipmentSetPayload,
    CalibrationPressureUnit
} from './types';

export const formatEquipmentSet = ({
    calibrations,
    ...equipmentSet
}: EquipmentSet): PostEquipmentSetPayload => {
    let formattedCalibrations;
    if (calibrations) {
        formattedCalibrations = calibrations.map(({ id, ...calibration }) => ({
            ...calibration
        }));
    }

    return {
        calibrations: formattedCalibrations,
        ...equipmentSet
    };
};

export const formatPressureUnit = (value: CalibrationPressureUnit): string => {
    let pressureUnit;

    switch (value) {
        case CalibrationPressureUnit.KPA:
            pressureUnit = 'kPa';
            break;
        case CalibrationPressureUnit.BAR:
            pressureUnit = 'bar';
            break;
        default:
            pressureUnit = '';
    }

    return pressureUnit;
};
